<template>
  <div class="new-banner">
    <p class="content">{{content}}</p>
    <p class="export">{{gettext('点击领取')}}<span></span></p>
  </div>
</template>
<script>
import {
  trackNewUserBannerSw
} from '../track'
export default {
  name: 'newBanner',
  props: {
    content: {
      type: String,
      default: ''
    },
    pageType: {
      type: Number,
      default: 0
    },
    trackCommonParams: {
      type: Object,
      default: () => {}
    },
    trackCouponInfo: {
      type: Object,
      default: () => {}
    }
  },
  mounted () {
    trackNewUserBannerSw({
      page_type: this.pageType,
      order_id: this.params.orderId,
      ...this.trackCouponInfo,
      ...this.trackCommonParams
    })
  }
}
</script>
<style lang="stylus" scoped>
@import "~@/common/stylus/main"
@import "~@/common/stylus/variables"
.new-banner
  width 100%
  height 300px
  background-size 100% 100%
  share-new-banner-bg()
  padding-left 48px
  box-sizing border-box
  .content
    padding:66px 80px 29px 0
  .export
    display flex
    align-items center
    font-family 'Aspira Medium'
    font-size 32px
    font-color()
    span
      margin-left 10px
      display inline-block
      width 9px
      height 16px
      arrow-right()
</style>